export const resetPasswordMock = {
	newPassword: 'sluMI863',
	returnCode: '0',
	message: '',
};

export default resetPasswordMock;
